var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmergencyNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168,
    height: 167,
    viewBox: "0 0 168 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "dial-111-b",
    width: 158,
    height: 157,
    x: 0,
    y: 0,
    rx: 5
  }), /*#__PURE__*/React.createElement("filter", {
    id: "dial-111-a",
    width: "110.1%",
    height: "110.2%",
    x: "-5.1%",
    y: "-4.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.129411765   0 0 0 0 0.239215686   0 0 0 0 0.345098039  0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "dial-111-c",
    d: "M0,0 L23.0001945,0 C35.7027116,0 46,10.2973093 46,23.0001997 C46,35.7026907 35.7027116,46 23.0001945,46 C10.2972884,46 0,35.7026907 0,23.0001997 L0,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#dial-111-a)",
    xlinkHref: "#dial-111-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#dial-111-b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 20)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AD3769",
    xlinkHref: "#dial-111-c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B4432F",
    xlinkHref: "#dial-111-c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.1293537,12.8571429 C14.1650891,12.8910494 14.2093329,12.9164794 14.2382615,12.9537766 L14.2382615,12.9537766 L19.246317,19.7639117 C19.251422,19.760521 19.2616321,19.755435 19.2667372,19.7486537 L19.2667372,19.7486537 L19.2667372,19.7673023 C17.5208096,20.9455557 17.6382258,22.510344 20.6689247,25.3195036 C23.8017246,28.2219062 25.5017067,28.2558127 26.7881797,26.4655457 L26.7881797,26.4655457 L26.8000915,26.4740224 L34.1428571,31.3175762 L32.808737,33.1027573 C31.5392809,34.5861698 30.225581,34.4403715 29.1092764,33.9249916 C29.1092764,33.9249916 22.8011345,31.9228085 18.1742562,27.6336271 C13.5473779,23.3427504 11.3879411,17.495562 11.3879411,17.495562 C10.8331922,16.4563255 10.6766373,15.2407749 12.2762201,14.0608262 L12.2762201,14.0608262 Z M27.2410454,25.7055831 C27.6952542,25.1137235 28.5899079,24.9657586 29.2368114,25.3790398 L29.2368114,25.3790398 L34.3913934,28.6733849 C35.0348559,29.0866662 35.1948613,29.9098273 34.7423729,30.5033877 L34.7423729,30.5033877 L34.4739768,30.8571429 L27.0500712,25.9947099 C27.0466302,25.9930092 27.0328663,25.9811039 27.0277049,25.9794032 C27.0500712,25.9504905 27.0724375,25.9300816 27.0948039,25.9011689 L27.0948039,25.9011689 Z M14.8758983,12.2356744 C15.5193608,11.8206924 16.4140146,11.9686573 16.8630619,12.5622176 L16.8630619,12.5622176 L20.4433974,17.3038976 C20.8924447,17.897458 20.7341599,18.7223198 20.0906973,19.1390026 L20.0906973,19.1390026 L19.8790773,19.2750623 C19.7775685,19.3345884 19.7035876,19.4009175 19.6124017,19.4621444 L19.6124017,19.4621444 L14.5507261,12.6319482 C14.5163163,12.5877288 14.4647017,12.5639184 14.4285714,12.5248012 L14.4285714,12.5248012 Z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#B4432F",
    fontFamily: "NunitoSans-Light, Nunito Sans",
    fontSize: 30,
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.3,
    y: 101
  }, "DIAL 111")), /*#__PURE__*/React.createElement("text", {
    fill: "#B4432F",
    fontFamily: "NunitoSans-Bold, Nunito Sans",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: 0.857,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22.635,
    y: 124
  }, "IN THE EVENT OF "), /*#__PURE__*/React.createElement("tspan", {
    x: 27.401,
    y: 140
  }, "AN EMERGENCY")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyNotice);
export default __webpack_public_path__ + "static/media/emergencyNotice.4edc4c37.svg";
export { ForwardRef as ReactComponent };